const initState = {
  sports: [],
  sportsData: [],
};
const sportReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_SPORTS":
      return {
        ...state,
        sports: action.payload,
      };
    case "GET_SPORTS_BY_IDS":
      return {
        ...state,
        sportsData: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default sportReducer;
